import { render, staticRenderFns } from "./UploadedNotes.vue?vue&type=template&id=306aca24&"
import script from "./UploadedNotes.vue?vue&type=script&lang=js&"
export * from "./UploadedNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports